import * as React from "react";

import { preventDefault } from "../utils/browser";

type TFormProps = React.ComponentProps<"form">;

/**
 * A React form that provides sensible defaults.
 *
 * The form, by default, prevents the default `onSubmit` handler.
 */
// Define TypeScript interface for props
interface Props {
  // Optional, provide a default
  onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void;

  [key: string]: unknown; // This line allows for additional props (like 'restProps')
}

export const Form: React.FC<TFormProps> = ({
  onSubmit = preventDefault(),
  ...restProps
}: Props) => {
  return <form onSubmit={onSubmit} {...restProps} />;
};
